
import Vue from 'vue';
import OwcHeaderButton from '@owc-packages/Header/src/HeaderButton.vue';
import OwcDataComponent from '@owc-utils/Mixins/OwcDataComponent';
import OwcLogo from '@owc-packages/Header/src/HeaderLogo.vue';
import SlotContainer from '@owc-packages/SlotContainer/src/SlotContainer.vue';
import {
  setupHostApi,
  dispatchCloseEvent,
  dispatchVisibilityEvent,
  FlyoutHost,
} from '@owc-utils/Seamless/flyoutIntegrations';
import headerMixin from '@owc-utils/Mixins/Header';
import { SecondaryFlyout, SecondaryFlyoutInstance } from './HeaderSecondaryFlyout';
import { handleFlyoutVisibilityOverride } from '../../_utils/Seamless/headerIntegrations';

export default (Vue as SecondaryFlyout).extend({
  name: 'owc-header-secondary-flyout',
  mixins: [headerMixin, OwcDataComponent],
  components: {
    OwcHeaderButton,
    OwcLogo,
    SlotContainer,
  },
  props: {
    open: {
      required: false,
      type: Boolean,
    },
    isInnerFlyout: {
      required: false,
      type: Boolean,
    },
    name: {
      required: true,
      type: String,
    },
    flyoutTitle: {
      required: false,
      type: String,
    },
    flyoutTitleCounter: {
      required: false,
      type: Number,
    },
    isLeftAligned: {
      required: false,
      type: Boolean,
    },
  },
  mounted() {
    setupHostApi(this, 'secondary-flyout-slide');

    if (this.open) {
      /**
       * Unfortunately we can't rely on simple events since that creates race conditions
       * between header created and event dispatched. So this override was created to ignore
       * the event and affect the store directly regardless of the header status.
       * This ensures that things like the region picker can initialize open even if it mounts
       * first than the header.
       *
       * The logic regarding the external integrations is already extremely complex, probably more than it
       * needs to be, but this will be refactored on the next PI (probably) when the header version INF is
       * released, which should have a leaner approach and not need most of this code.
       */
      handleFlyoutVisibilityOverride(this as SecondaryFlyoutInstance, this.$el as FlyoutHost, {
        isOpen: this.open,
        name: this.name,
        isInnerFlyout: this.isInnerFlyout,
      });
    }
  },
  data() {
    return {
      isInitialized: false,
    };
  },
  watch: {
    open(isOpen) {
      dispatchVisibilityEvent(this, { isOpen, name: this.name, isInnerFlyout: this.isInnerFlyout });
    },
  },
  methods: {
    handleFlyoutCloseClick() {
      dispatchCloseEvent(this);
    },
    handleFlyoutBackClick() {
      dispatchVisibilityEvent(this, {
        isOpen: false,
        name: this.name,
        isInnerFlyout: this.isInnerFlyout,
        isBackInteraction: true,
      });
    },
  },
});
